const booking = {
  bookingInformation: "מידע על הזמנה", // translated
  ourCancellationPolicy: "מדיניות הביטולים שלנו", // translated
  thisAupersedesAnyCancellationPolicyInRemarksAbove: "זה מחליף כל מדיניות ביטול בהערות לעיל", // translated
  thisBookingIsNonNefundable: "הזמנה זו אינה ניתנת להחזר", // translated
  paymentTerms: "תנאי תשלום", // translated
  paymentWillBeTakenFromYourDefault: "התשלום יילקח מברירת המחדל שלך", // translated
  paymentMethod: "אמצעי תשלום", // translated
  afterTheFreeCancellationPeriodIfApplicable: "לאחר תקופת הביטול בחינם אם רלוונטי", // translated
  prebook: "הזמנה מראש", // translated
  guests: "אורחים", // translated
  payment: "תַשְׁלוּם", // translated
  byClicking: "על ידי לחיצה", // translated
  youAreAgreeingToOur: "אתה מסכים שלנו", // translated
  termsAndConditions: "תנאים", // translated
  lastBookableDate: "תאריך אחרון להזמנה", // translated
  customerRemarksTextfield: "הערות לקוחות", // translated
  request: "בַּקָשָׁה", // translated
};

export default booking;
